import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// 引入各个语言配置文件
import ar from './lang/ar';
import de from './lang/de';
import en from './lang/en';
import es from './lang/es';
import fr from './lang/fr';
import hi from './lang/hi';
import id from './lang/id';
import it from './lang/it';
import ja from './lang/ja';
import ko from './lang/ko';
import pt from './lang/pt';
import ru from './lang/ru';
import th from './lang/th';
import tr from './lang/tr';
import vi from './lang/vi';
import zh_HK from './lang/zh_HK';
import zh from './lang/zh';
import {isBondo} from "../util";
// 创建vue-i18n实例i18n

let jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
let lang = jsSrc.substr(0,2);
if (jsSrc == 'zh-mo' || jsSrc == 'zh-tw' || jsSrc == 'zh-hk' || jsSrc == 'zh-rHK' || jsSrc.indexOf("zh-hant") != -1) {
	lang = 'zh_HK';
}
document.body.className+=" "+lang
if(lang=='ar'){
    document.body.style.direction='rtl';
}
if(isBondo()) {
  lang = 'en'
}
const i18n = new VueI18n({
    // 设置默认语言
    locale: lang || 'en',  // 语言标识
    fallbackLocale: 'en', //如果没有找到要显示的语言，则默认显示 ‘en’
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        ar, de, en, es, fr, hi, id, it, ja, ko, pt, ru, th, tr, vi, zh_HK, zh,
    }
})
// 暴露i18n
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js